/* LS2 product page helpers
   - "Only X left" badges on size buttons (Swatch King + native picker) for the selected colour
   - Delivery estimate as real dates (Egypt: Friday off)
   - Keeps the "take 3, pay for 2" maths in sync with the selected variant price
   - One-tap add for the cart drawer "Complete your 3" picks */
(() => {
  if (window.ls2Pdp) return;
  const ar = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
  const SIZE = /size|مقاس|حجم/i;
  const COLOUR = /colou?r|لون/i;
  const LOW = 2;

  const readStock = (root) => {
    const el = root.querySelector('script[data-ls2-stock]');
    if (!el) return null;
    if (el._ls2) return el._ls2;
    try {
      const data = JSON.parse(el.textContent);
      data.sizeIdx = data.options.findIndex((o) => SIZE.test(o));
      data.colourIdx = data.options.findIndex((o) => COLOUR.test(o));
      data.shipMin = Number(el.dataset.shipMin) || 2;
      data.shipMax = Number(el.dataset.shipMax) || 5;
      el._ls2 = data;
      return data;
    } catch (e) {
      return null;
    }
  };

  const currentVariant = (root, data) => {
    const input = root.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector(`input[name="id"][form="${root.querySelector('form[action*="/cart/add"]')?.id}"]`);
    const id = Number(input?.value);
    return data.variants.find((v) => v.id === id) || data.variants.find((v) => v.a) || data.variants[0];
  };

  const money = (cents) => {
    const value = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `LE ${value}`;
  };

  const badgeText = (q) => (ar ? `باقي ${q}` : `Only ${q} left`);

  const setBadge = (host, q) => {
    let badge = host.querySelector(':scope > .ls2-left');
    if (q && q > 0 && q <= LOW) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ls2-left';
        host.appendChild(badge);
      }
      const text = badgeText(q);
      if (badge.textContent !== text) badge.textContent = text;
    } else if (badge) {
      badge.remove();
    }
  };

  const updateSizes = (root, data) => {
    if (data.sizeIdx < 0) return;
    const v = currentVariant(root, data);
    const colour = data.colourIdx >= 0 && v ? v.o[data.colourIdx] : null;
    const qtyFor = (size) => {
      const match = data.variants.find((x) => x.o[data.sizeIdx] === size && (colour === null || x.o[data.colourIdx] === colour));
      return match && match.a ? match.q : 0;
    };
    // Swatch King buttons
    root.querySelectorAll('variant-swatch-king [option-name] li.swatch-view-item[orig-value]').forEach((li) => {
      const group = li.closest('[option-name]');
      if (!SIZE.test(group.getAttribute('option-name'))) return;
      setBadge(li, qtyFor(li.getAttribute('orig-value')));
    });
    // Native buttons (fallback when the app is off)
    root.querySelectorAll('variant-selects fieldset').forEach((fs) => {
      if (!SIZE.test(fs.querySelector('legend')?.textContent || '')) return;
      fs.querySelectorAll('input[type=radio]').forEach((input) => {
        const label = fs.querySelector(`label[for="${input.id}"]`);
        if (label) setBadge(label, qtyFor(input.value));
      });
    });
  };

  const updateCalc = (root, data) => {
    const calc = root.querySelector('[data-ls2-calc]');
    if (!calc) return;
    const v = currentVariant(root, data);
    if (!v || Number(calc.dataset.price) === v.p) return;
    calc.dataset.price = v.p;
    const pay = v.p * 2;
    calc.querySelector('[data-ls2-calc-three]').textContent = money(v.p * 3);
    calc.querySelector('[data-ls2-calc-pay]').textContent = money(pay);
    calc.querySelector('[data-ls2-calc-per]').textContent = money(Math.round(pay / 3));
  };

  // Delivery dates: business days, Friday is the day off
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    let left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 5) left -= 1;
    }
    return d;
  };
  const fmt = new Intl.DateTimeFormat(ar ? 'ar-EG' : 'en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
  const updateDelivery = (root, data) => {
    const el = root.querySelector('.ls-delivery-estimate');
    if (!el || el.dataset.ls2Done) return;
    const now = new Date();
    const from = fmt.format(addBusinessDays(now, data.shipMin));
    const to = fmt.format(addBusinessDays(now, data.shipMax));
    const link = el.querySelector('a');
    el.textContent = '';
    const strong = document.createElement('strong');
    strong.textContent = ar ? `اطلب دلوقتي، يوصلك ما بين ${from} و${to}.` : `Order now, delivered between ${from} and ${to}.`;
    el.append(strong, document.createTextNode(ar ? ' الدفع كاش عند الاستلام. ' : ' Pay cash on delivery. '));
    if (link) el.append(link);
    el.dataset.ls2Done = '1';
  };

  const refresh = (root) => {
    const data = readStock(root);
    if (!data) return;
    updateSizes(root, data);
    updateCalc(root, data);
    updateDelivery(root, data);
  };

  // Collection filters: list size values XS → XXL instead of A–Z
  const SIZE_RANK = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL'];
  const sizeRank = (li) => {
    const value = li.querySelector('input')?.value || '';
    const i = SIZE_RANK.indexOf(value.trim().split(/[\s(]/)[0].toUpperCase());
    return i < 0 ? 99 : i;
  };
  const sortSizeFilters = () => {
    document.querySelectorAll('ul.facets__list, ul.mobile-facets__list').forEach((list) => {
      if (!/size/i.test(list.querySelector('input')?.name || '')) return;
      const items = [...list.children].filter((el) => el.tagName === 'LI');
      const sorted = [...items].sort((a, b) => sizeRank(a) - sizeRank(b));
      if (sorted.every((el, i) => el === items[i])) return;
      sorted.forEach((el) => list.appendChild(el));
    });
  };

  // Product cards: colour thumbnails stay on one row; the last slot becomes "+N"
  const fitColours = () => {
    document.querySelectorAll('.ls-size-colors__options').forEach((row) => {
      const items = [...row.querySelectorAll('.ls-size-color')];
      if (!items.length || !row.clientWidth) return;
      const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      const itemWidth = items[0].offsetWidth || 30;
      const fits = Math.max(1, Math.floor((row.clientWidth + gap) / (itemWidth + gap)));
      const visible = items.length > fits ? fits - 1 : items.length;
      const key = `${row.clientWidth}:${items.length}:${visible}`;
      if (row.dataset.ls2Fit === key) return;
      row.dataset.ls2Fit = key;
      items.forEach((item, i) => { item.hidden = i >= visible; });
      let more = row.querySelector('.ls2-more');
      if (visible < items.length) {
        if (!more) {
          more = document.createElement('a');
          more.className = 'ls2-more';
          row.appendChild(more);
        }
        more.href = items[0].dataset.sizeUrl || '#';
        more.textContent = `+${items.length - visible}`;
        more.setAttribute('aria-label', ar ? `${items.length - visible} ألوان كمان` : `${items.length - visible} more colours`);
      } else if (more) {
        more.remove();
      }
    });
  };

  // Arabic labels the theme translation gets wrong in the filter drawer
  const fixFilterLabels = () => {
    if (!ar) return;
    document.querySelectorAll('.mobile-facets__clear').forEach((el) => { if (el.textContent.trim() === 'واضح') el.textContent = 'مسح'; });
    document.querySelectorAll('.mobile-facets__footer .button--primary').forEach((el) => { if (el.textContent.trim() === 'تقديم') el.textContent = 'عرض النتائج'; });
  };

  // Product cards: one-line titles; long ones scroll into view on hover
  const fitTitles = () => {
    document.querySelectorAll('.card-wrapper .card__heading').forEach((heading) => {
      const link = heading.querySelector('a') || heading;
      let run = link.querySelector(':scope > .ls2-title-run');
      if (!run) {
        const text = [...link.childNodes].filter((n) => n.nodeType === 3 && n.textContent.trim());
        if (!text.length) return;
        run = document.createElement('span');
        run.className = 'ls2-title-run';
        run.textContent = text.map((n) => n.textContent).join(' ').replace(/\s+/g, ' ').trim();
        text.forEach((n) => n.remove());
        link.prepend(run);
      }
      if (!heading.clientWidth) return;
      const overflow = Math.ceil(run.scrollWidth - heading.clientWidth);
      const long = overflow > 2;
      heading.classList.toggle('is-long', long);
      if (long) {
        const shift = `${(document.documentElement.dir === 'rtl' ? 1 : -1) * (overflow + 4)}px`;
        if (heading.style.getPropertyValue('--ls2-shift') !== shift) {
          heading.style.setProperty('--ls2-shift', shift);
          heading.style.setProperty('--ls2-dur', `${Math.min(4, Math.max(0.8, overflow / 45)).toFixed(2)}s`);
        }
      }
    });
  };

  const scan = () => {
    document.querySelectorAll('product-info').forEach(refresh);
    sortSizeFilters();
    fitColours();
    fitTitles();
    fixFilterLabels();
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  };
  new MutationObserver((records) => {
    // ignore our own badge edits
    if (records.every((r) => [...r.addedNodes, ...r.removedNodes].every((n) => n.nodeType === 1 && n.classList?.contains('ls2-left')))) return;
    schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', () => setTimeout(schedule, 120), true);

  // Cart drawer: one-tap add in the shopper's size
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ls2-quick-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const label = button.textContent;
    button.disabled = true;
    button.textContent = button.dataset.adding;
    try {
      const mainItems = document.getElementById('main-cart-items');
      const mainFooter = document.getElementById('main-cart-footer');
      const itemsSection = mainItems?.dataset.id || 'main-cart-items';
      const footerSection = mainFooter?.dataset.id || 'main-cart-footer';
      const sections = [...new Set(['cart-drawer', 'cart-icon-bubble', itemsSection, footerSection])];
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.ls2QuickAdd), quantity: 1 }], sections, sections_url: location.pathname })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'add failed');
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections?.['cart-drawer']) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      }
      for (const [id, section, selector] of [['main-cart-items', itemsSection, '.js-contents'], ['main-cart-footer', footerSection, '.js-contents'], ['cart-icon-bubble', 'cart-icon-bubble', '.shopify-section']]) {
        const target = document.getElementById(id);
        const html = data.sections?.[section];
        if (!target || !html) continue;
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        if (source) (target.querySelector(selector) || target).innerHTML = source.innerHTML;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ls2-complete-three', productVariantId: button.dataset.ls2QuickAdd, cartData: data });
      }
      customElements.get('cart-offer-progress')?.refresh?.();
    } catch (error) {
      button.disabled = false;
      button.textContent = button.dataset.error || label;
      setTimeout(() => { button.textContent = label; }, 2500);
    }
  });

  // Sticky bars (collection filters) sit right under the sticky announcement + header
  let lastOffset = -1;
  const setHeaderOffset = () => {
    let bottom = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach((el) => {
      const pos = getComputedStyle(el).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      const r = el.getBoundingClientRect();
      if (r.height && r.top <= bottom + 1) bottom = Math.max(bottom, r.bottom);
    });
    bottom = Math.max(0, Math.round(bottom));
    if (bottom !== lastOffset) {
      lastOffset = bottom;
      document.documentElement.style.setProperty('--ls-header-h', `${bottom}px`);
    }
  };
  let offsetQueued = false;
  const queueOffset = () => {
    if (offsetQueued) return;
    offsetQueued = true;
    requestAnimationFrame(() => { offsetQueued = false; setHeaderOffset(); });
  };
  window.addEventListener('scroll', queueOffset, { passive: true });
  window.addEventListener('resize', () => { queueOffset(); schedule(); });
  queueOffset();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  window.ls2Pdp = { scan };
})();
